export const SECOES = {
    SOLICITANTE: 'solicitante',
    DADOS_DO_PACIENTE: 'dadosDoPaciente',
    INFORMACOES_CLINICAS: 'informaçõesClínicas',
};

/** Chaves exclusivas usadas como `key` em elementos React */
export const REACT_KEYS = {
    BTN_ENVIAR: 'btn-enviar',
    SEC_DADOS_DO_PACIENTE: 'sec-dados-do-paciente',
    SEC_SOLICITANTE: 'sec-solicitante',
    SEC_INFORMACOES_CLINICAS: 'sec-informacoes-clínicas'
};
